import { Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { ResourcesLayout } from "./resources-layout";
import { getArchivedResources } from "../request/get-archive-resources";
export const ArchivedResourcesPage = () => {
    const [archivedResources, setArchivedResources] = React.useState([]);
    React.useEffect(() => {
        getArchivedResources().then((resources) => {
            setArchivedResources(resources);
        });
    }, []);
    return (React.createElement(Stack, { direction: "column", alignItems: "center", padding: 3, spacing: 2, style: { flex: 1, overflow: "hidden" } },
        React.createElement(Paper, { elevation: 3, style: {
                padding: "16px",
                flex: 1,
                overflow: "auto",
                width: "100%",
            } },
            React.createElement(Stack, { direction: "column", spacing: 2 },
                React.createElement(Typography, { variant: "h4" }, "Archived Resources"),
                React.createElement(ResourcesLayout, { resources: archivedResources })))));
};
